export const KIND_META = {
  procedures: {
    label: "Procedimentos",
    format: "nome; valor bruto; código SUS; especialidade; retenção %",
    example:
      "Hernioplastia inguinal unilateral; 1200; 0407040110; Geral; 30\nColecistectomia videolaparoscópica; 1850.50; 0407030064; Geral;",
    hint: "Campos vazios são aceitos (deixe só o ponto e vírgula). Retenção vazia usa o padrão das Configurações.",
  },
  surgeons: {
    label: "Cirurgiões",
    format: "nome completo (um por linha)",
    example: "Altamir Lago\nCamilla Lago",
    hint: "Todos serão cadastrados como membros da equipe. Sem Dr./Dra., sem CRM.",
  },
  anesthesiologists: {
    label: "Anestesistas",
    format: "nome completo (um por linha)",
    example: "João Pedro Almeida\nMariana Souza Costa",
    hint: "Um nome por linha. Sem Dr./Dra., sem CRM.",
  },
};

export const AI_PROMPT = `Preciso que você transforme a lista abaixo em TEXTO PURO, para importação em massa.
Regras absolutas:
- Uma entidade por linha. Campos separados por ponto e vírgula (;).
- NÃO use cabeçalho, NÃO use markdown, NÃO use tabela, NÃO use bullets, NÃO numere.
- NÃO invente dados. Campo desconhecido = deixe VAZIO (só o ponto e vírgula).
- Não repita a mesma entidade duas vezes.
- Responda APENAS com as linhas, dentro de um bloco de código.

FORMATO 1 — PROCEDIMENTOS (5 campos):
nome; valor bruto; codigo SUS; especialidade; retencao %
- nome: nome do procedimento, sem qualificadores como "urgência"/"eletiva"
- valor bruto: só números, ponto como decimal. Ex: 1200 ou 1200.50 (NÃO use R$, NÃO use ponto de milhar)
- codigo SUS: 10 dígitos, sem pontos
- especialidade: ex. Geral, Ortopedia, Urologia, Ginecologia
- retencao %: só o número, ex. 30 (= 30%). Vazio = usa o padrão do sistema
Exemplo:
Hernioplastia inguinal unilateral; 1200; 0407040110; Geral; 30
Colecistectomia videolaparoscópica; 1850.50; 0407030064; Geral;

FORMATO 2 — CIRURGIÕES (1 campo):
nome completo
- Nome completo, com acentos, sem "Dr."/"Dra.", sem CRM, sem especialidade
Exemplo:
Altamir Lago
Camilla Lago

FORMATO 3 — ANESTESISTAS (1 campo):
nome completo
- Mesmas regras dos cirurgiões
Exemplo:
João Pedro Almeida

Devolva os três blocos separados, rotulados como PROCEDIMENTOS, CIRURGIÕES e ANESTESISTAS.
Aqui está a lista bruta:
<<< COLE SUA LISTA AQUI >>>`;
